import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/solid';

interface BreadcrumbsProps {
  items: {
    name: string;
    href?: string;
  }[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <nav className="flex mb-8" aria-label="Breadcrumb navigation">
      <ol 
        className="flex items-center space-x-1" 
        role="list" 
        aria-label="Breadcrumb links"
      >
        <li className="flex items-center">
          <Link 
            to="/" 
            className="text-gray-600 hover:text-primary-700 focus:outline-none rounded-md p-1 transition-colors"
            aria-label="Navigate to home page"
          >
            <HomeIcon className="h-5 w-5" aria-hidden="true" />
            <span className="sr-only">Home</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.name} className="flex items-center">
            <ChevronRightIcon 
              className="h-5 w-5 flex-shrink-0 text-gray-500" 
              aria-hidden="true" 
            />
            {index === items.length - 1 ? (
              <span 
                className="ml-1 text-sm font-medium text-gray-900" 
                aria-current="page"
              >
                {item.name}
              </span>
            ) : (
              <Link
                to={item.href || '#'}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-primary-700 focus:outline-none rounded-sm transition-colors"
                aria-label={`Navigate to ${item.name}`}
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs; 